module.exports = __webpack_public_path__ + "static/media/12UNCTAD7.9c93bb65.jpg";